import { render, staticRenderFns } from "./NextArrow.vue?vue&type=template&id=1bc451fa&"
import script from "./NextArrow.vue?vue&type=script&lang=js&"
export * from "./NextArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports